import { VisitaEvolucaoFiltrosDTO } from '@/interfaces/crm-visit-evolution';
import { ENDPOINTS } from '@/settings/api-settings';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { apiClient } from './api';

export function listCrmVisitEvolutionVisitorsOptions(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_EVOLUTION_VISITORS_OPTIONS)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    })
  );
}

export function listCrmVisitEvolutionData(parm: VisitaEvolucaoFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_EVOLUTION, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    })
  );
}

export function listCrmVisitEvolutionVisitorsData(parm: VisitaEvolucaoFiltrosDTO): Observable<any> {
  return from(apiClient.get(ENDPOINTS.CRM_VISIT_EVOLUTION_VISITORS, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    })
  );
}
